<template>
  <div class="page-users">
    <div class="container mt-5">

      <div class="page-header">
        <div>
          <h1 class="title is-3 mb-2">Users</h1>
          <p class="subtitle is-6 has-text-grey">
            Manage user accounts and access.
          </p>
        </div>

        <router-link to="/users/add" class="button is-primary">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>
          <span>Add User</span>
        </router-link>
      </div>

      <div class="box users-card">
        <div v-if="loading" class="has-text-centered p-5">
          <button class="button is-primary is-loading" disabled>
            Loading
          </button>
        </div>

        <div v-else class="table-container">
          <table class="table is-fullwidth is-hoverable users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>First Name</th>
                <th>Email</th>
                <th>Admin</th>
                <th>Active</th>
                <th class="has-text-right">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td class="has-text-grey">#{{ user.id }}</td>
                <td>
                  <strong>{{ user.first_name || 'Unnamed User' }}</strong>
                </td>
                <td>{{ user.email }}</td>

                <td>
                  <span
                    class="tag"
                    :class="user.is_staff ? 'is-success is-light' : 'is-light'"
                  >
                    {{ user.is_staff ? 'Admin' : 'User' }}
                  </span>
                </td>

                <td>
                  <span
                    class="tag"
                    :class="user.is_active ? 'is-success is-light' : 'is-danger is-light'"
                  >
                    {{ user.is_active ? 'Active' : 'Inactive' }}
                  </span>
                </td>

                <td class="has-text-right">
                  <div class="buttons is-right">
                    <router-link
                      :to="`/users/${user.id}/edit`"
                      class="button is-small is-info is-light"
                    >
                      <span class="icon is-small">
                        <i class="fas fa-edit"></i>
                      </span>
                      <span>Edit</span>
                    </router-link>

                    <button
                      class="button is-small"
                      :class="
                        Number(user.id) === Number(currentUser?.id)
                          ? 'is-light'
                          : 'is-danger is-light'
                      "
                      type="button"
                      :disabled="Number(user.id) === Number(currentUser?.id)"
                      @click="deleteUser(user.id)"
                    >
                      <span class="icon is-small">
                        <i
                          class="fas"
                          :class="
                            Number(user.id) === Number(currentUser?.id)
                              ? 'fa-lock'
                              : 'fa-trash'
                          "
                        ></i>
                      </span>

                      <span>
                        {{
                          Number(user.id) === Number(currentUser?.id)
                            ? 'Current User'
                            : 'Delete'
                        }}
                      </span>
                    </button>
                    
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'

export default {
  name: 'UsersView',

  computed: {
    currentUser() {
      return this.$store.state.user
    }
  },

  data() {
    return {
      users: [],
      loading: false
    }
  },

  mounted() {
    document.title = 'Users | SCE Electrical'
    this.getUsers()
  },

  methods: {
    showToast(message, type = 'is-success') {
      toast({
        message,
        type,
        dismissible: true,
        pauseOnHover: true,
        duration: 4000,
        position: 'bottom-right'
      })
    },

    async getUsers() {
      this.loading = true
      this.$store.commit('setIsLoading', true)

      try {
        const response = await axios.get('/api/v1/users/')
        this.users = response.data
      } catch (error) {
        console.log(error)
        this.showToast('Could not load users. Please try again.', 'is-danger')
      } finally {
        this.loading = false
        this.$store.commit('setIsLoading', false)
      }
    },

    async deleteUser(userId) {
      if (!confirm('Are you sure you want to delete this user?')) {
        return
      }

      try {
        await axios.delete(`/api/v1/users/${userId}/`)

        this.showToast('User deleted successfully')

        this.users = this.users.filter(user => user.id !== userId)
      } catch (error) {
        console.log(error)
        this.showToast('Error deleting user', 'is-danger')
      }
    }
  }
}
</script>

<style scoped>
.page-users {
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.users-card {
  border-radius: 12px;
}

.users-table {
  margin-bottom: 0;
}

.users-table th {
  color: #7a7a7a;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.users-table td,
.users-table th {
  vertical-align: middle;
}

.buttons {
  margin-bottom: 0;
}

@media screen and (max-width: 768px) {
  .page-header {
    flex-direction: column;
  }

  .page-header .button {
    width: 100%;
  }
}
</style>